export const invoicesdb = [
    { value: '01', label: 'Factura', id:"3" },
    { value: '03', label: 'Comprobante de crédito fiscal', id:"4" },
    { value: '11', label: 'Facturas de exportación', id:"11" },
    { value: "14", label: "Sujeto excluido", id: 12}
  ]

  export const invoicesNotesdb = [
   
    { value: '06', label: 'Nota de Débito', id: "7" },
    { value: '05', label: 'Nota de Crédito', id: "6" },
    { value: '08', label: 'Invalidación',  id: "105"},
    
  ]